import { createFileRoute } from '@tanstack/react-router';

// Component body lives in admin.lazy.tsx — keeps it out of the initial
// JS chunk per Phase Bundle-Splitting-1.
export const Route = createFileRoute('/$locale/admin')({
  ssr: false,
});
